export const INITIAL_STATE = {
  currentValue: "0",
  initial: true,
  previousValue: undefined,
  operator: undefined,
};
